
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
  model: {
    prop: 'modelValue',
    event: 'change',
  }
})
export default class UpsellItemQuantity extends Vue {
    @Prop({ type: Object }) item: UpsellItem;
    @Prop({ type: Number, default: 0 }) modelValue: number;
    @Prop({ type: String, default: 'normal' }) size: string;
    @Prop({ type: String, default: 'quantity' }) variant: string;
    @Prop({ type: Boolean, default: false }) disabled: boolean;
    @Prop({ type: Boolean, default: false }) loading: boolean;

    get value() {
      return this.modelValue;
    }

    set value(value) {
      this.$emit('change', value);
    }

    mounted() {
      this.$emit('change', this.modelValue || 1);
    }

    get classes() {
      return {
        'vue-button-red': this.variant === 'primary',
        'vue-button-gray': this.variant === 'secondary',
        'vue-button-darkgray': this.variant === 'tertiary',
      }
    }

    get disableMin() {
      return this.disabled || this.modelValue === (this.item.minQuantity || 1);
    }

    get disableMax() {
      return this.disabled || this.modelValue === (this.item.maxQuantity || 99);
    }

    handleQuantityChange(event) {
      let newValue = parseInt(event.target.value, 10);
      if (newValue <= 0) {
        newValue = 1;
      } else if (newValue > 99) {
        newValue = 99
      }
      this.value = newValue
    }
}
